import { JobArea } from '@crimsontide/core/client/interfaces';
import DotNetObject = DotNet.DotNetObject;

export const JobAreaService = (() => {
  let dotNetObj: DotNetObject;
  let cachedJobAreas: JobArea[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getJobAreas = async (useCache: boolean = true): Promise<JobArea[]> => {
    if (useCache && cachedJobAreas != null)
      return cachedJobAreas;

    if (dotNetObj) {
      cachedJobAreas = await dotNetObj.invokeMethodAsync<JobArea[]>('GetAllAsync');
      return cachedJobAreas;
    } else {
      throw 'Job Area DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getJobAreas,
  };
})();
